import React, { useContext, useEffect, useState } from "react";
import { apiPut, apiDelete, apiGet } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillDelete, AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort, BsFileEarmarkPdfFill } from "react-icons/bs";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import helper from "../../../utils/helpers";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Pagination from "pages/Pagination";
import View from "../view";
import ServiceProviderModal from "../serviceProviderModal"
import ServiceProviderViewModal from "../serviceProviderViewModal"
import DesView from "../descriptionViewModal";

const LiveStockOnFieldServiceProviderList = ({
  // serviceProviders,
  // setServiceProviders,
  // getServiceProvider,
  page,
  setPage,
  sort,
  setSort,
  manager,
  // paginationObj,
  handlePageClick,
  livestockServiceId
}) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const notification = useToastContext();
  const [details, setDetails] = useState('')
  const [viewShowModal, setViewShowModal] = useState(false)
  const [serviceProviders, setServiceProviders] = useState([])
  // const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [isDelete, setIsDelete] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [item, setItem] = useState('')
  const [description, setDescription] = useState('')
  const [viewDesShowModal, setViewDesShowModal] = useState(false)
  const [filterData, setFilterData] = useState({
    status: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  // const [sort, setSort] = useState({
  //   sortKey: 'createdAt',
  //   sortType: 'desc'
  // })
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  // const manager = user?.permission?.find(e => e.manager === 'category') ?? {}

  const handelResponse = async (item, status) => {
    try {
      const payload = {
        status
      }
      const path = `${apiPath.serviceProviderList}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {

        notification.success(result.data.message)
        // getServiceListData('insurance')
      }
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  const getServiceProvider = async (id) => {
    try {
      const { category, searchkey } = filterData
      const payload = {
        page,
        pageSize,
        status: category,
        keyword: searchkey?.trim(),
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        service: id ? id : livestockServiceId
      }
      const path = `${apiPath.serviceProviderList}`
      const result = await apiGet(path,payload)
      if (result?.status === 200) {
        setServiceProviders(result.data.results.docs)
        const response = result?.data?.results
        const resultStatus = result?.data?.success

        setPaginationObj({
            ...paginationObj,
            page: resultStatus ? response.page : null,
            pageCount: resultStatus ? response.totalPages : null,
            perPageItem: resultStatus ? response?.docs.length : null,
            totalItems: resultStatus ? response.totalDocs : null
          })
      }
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.serviceProviderChangeStatus}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        getServiceProvider()
      }
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  function Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // const handlePageClick = (event) => {
  //   const newPage = event.selected + 1
  //   setPage(newPage)
  // }

  const handleUserView = (item) => {
    setDetails(item)
    setViewShowModal(true)
  }

  const toggleViewModal = (item) => {
    setViewShowModal(!viewShowModal)
    setItem(item ?? {})
  }


  const handleSearchKey = (e) => {
    setFilterData({...filterData, searchkey:e.target.value, isFilter:true})
    setPage(1)
  }

  const handleReset = () => {
    setFilterData({category:'',searchkey:'',isReset:true, isFilter:false})
    setPage(1)
    setIsDelete(true)
  }

  const statusPage = (e) =>{
    setFilterData({...filterData, category:e.target.value, isFilter:true})
    setPage(1)
    setIsDelete(true)
  }

  const toggleModal = (item) => {
    setShowModal(!showModal)
    setItem(item ?? {})
  }

  const handleDescriptionView = (item) => {
    setDescription(item)
    setViewDesShowModal(true)
  }

  useEffect(() => {
    getServiceProvider(livestockServiceId)
  }, [ page, filterData, sort ])

  return (
    <div>
      <div className=''>
        <div className=''>
        {/* <span
          className="flex  items-center cursor-pointer"
          onClick={() => navigate("/categories")}
        >
          <BiArrowBack className="h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer mb-2" />
          <span className="ml-2">{t("O_BACK")}</span>
        </span> */}
          <div className='bg-white  rounded-lg'>
            <div className='grid md:grid-cols-2 pt-5'>
              <div className='flex flex-wrap  items-center'>
                <div className='flex items-center flex-wrap justify-start'>
                <div className='flex items-center mb-3'>
                  <div className='flex'>
                    <div className='relative '>
                      <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                        {(
                          <svg
                            aria-hidden='true'
                            className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                            />
                          </svg>
                        )}
                      </div>
                      <input
                        // type='search'
                        id='default-search'
                        className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                        placeholder={t('O_SEARCH_BY_FULL_NAME')}
                        value={filterData?.searchkey}
                        title=''
                        required
                        onChange={(e) => handleSearchKey(e)}
                      />
                    </div>
                  </div>
                </div>
                  <div className='flex items-center mb-3 ml-3'>
                    <select
                      id='countries'
                      type=' password'
                      name='floating_password'
                      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      value={filterData?.category}
                      onChange={(e)=>statusPage(e)}
                    >
                      <option defaultValue value=''>
                        {t('O_ALL')}
                      </option>
                      <option value='active'>{t('O_ACTIVE')}</option>
                      <option value='inactive'>{t('O_INACTIVE')}</option>
                    </select>
                  </div>
                  <button
                    type='button'
                    onClick={handleReset}
                    className='bg-LightBlue text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button>
                </div>
              </div>
              <div className='flex items-start md:justify-end px-3'>
              {(manager?.add ||
                user?.role==='admin') && (
                <button
                  type='button'
                  className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                  onClick={() => setShowModal(true)}
                >
                  {t('O_ADD_NEW')}
                </button>
              )}
              </div>
            </div>
            <div className="pt-3">
      <div className="overflow-x-auto relative rounded-lg border">
      <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-2">
                #
              </th>
              <th
                scope="col"
                className="py-3 px-2"
              >
                <div className="flex">
                  <span>{t("USERS_FULL_NAME")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2"
              >
                <div className="flex">
                  <span>{t("O_LOGO")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2"
              >
                <div className="flex">
                  <span>{t("O_MOBILE_NUMBER")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2"
              >
                <div className="flex">
                  <span>{t("O_CATEGORY")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2"
              >
                <div className="flex">
                  <span>{t("O_DESCRIPTION")} </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (sort?.sortKey === "createdAt" && sort?.sortType === "asc") {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "createdAt",
                      sortType: "asc",
                    });
                  }
                }}
              >
                <div className="flex">
                  <span>{t("O_CREATED_AT")} </span>
                  <span>
                    {sort?.sortKey === "createdAt" &&
                      sort?.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort?.sortKey === "createdAt" &&
                      sort?.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              {(manager?.add || user?.role === 'admin') && (
                <th
                scope='col'
                className='py-3 px-2 text-center'
                onClick={() => {
                  if (sort?.sortKey === "status" && sort?.sortType === "asc") {
                    setSort({
                      sortKey: "status",
                      sortType: "desc",
                    });
                  } else {
                    setSort({
                      sortKey: "status",
                      sortType: "asc",
                    });
                  }
                }}
                >
                  {t('O_STATUS')}
                  <span>
                    {sort?.sortKey === "status" &&
                      sort?.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort?.sortKey === "status" &&
                      sort?.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </th>
              )}
              <th
                scope="col"
                className="py-3 px-2"
              >
                <div className="flex">
                  <span>{t("O_PDF")} </span>
                </div>
              </th>
              {(manager?.add || user?.role === "admin") && (
                <>
                  <th scope="col" className="py-3 px-2 text-center">
                    {t("O_ACTION")}
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {serviceProviders &&
              serviceProviders?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-2 px-2 border-r">
                    {item?.name}
                  </td>
                  <td className="py-2 px-2 border-r text-center">
                    <img className="h-10 w-10 rounded-full" src={item?.logo} alt="img"/>
                  </td>
                  <td className="py-2 px-2 border-r">{'+' + item?.countryCode+' ' + item?.mobile}</td>
                  <td className="py-2 px-2 border-r">
                    {item?.category?.title}
                  </td><td className="py-2 px-2 border-r">
                    {(item?.description). slice(0,50)}{item?.description?.length > 50 && <span className='text-black cursor-pointer' onClick={()=> handleDescriptionView(item?.description)}> {t('O_READ_MORE')}</span>}
                  </td>
                  <td className="py-2 px-2 border-r">
                    {dayjs(item?.createdAt).format("lll")}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-2 px-2 border-r text-center'>
                    <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                        item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                    >
                        <input
                        type='checkbox'
                        className='sr-only peer'
                        checked={item?.status === 'active'}
                        onChange={e =>
                            helper.alertFunction(
                            `${t('ARE_YOU_SURE')} ${
                                e.target.checked ? t('O_ACTIVE_SMALL') : t('O_INACTIVE_SMALL')
                            } this service provider?`,
                            item,
                            handelStatusChange
                            )
                        }
                        // onChange={(e) => handelStatusChange(item)(e)}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                    </label>
                    </td>
                  )}
                  <td className="py-2 px-2 border-r">
                    <a href={item?.pdf} target="_blank" rel="noreferrer"><BsFileEarmarkPdfFill className="text-black text-xl"/></a>
                  </td>
                  <td className="py-2 px-2 border-l">
                    <div className="">
                      <ul className="flex justify-center items-center">
                      {(manager?.add ||
                          user?.role === 'admin') && (
                            <li
                              onClick={() => toggleModal(item)}
                              className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                            >
                              <span
                                title={t('O_EDIT_EDIT')}
                                className='hover:text-blue-700 transition duration-150 ease-in-out'
                                data-bs-toggle='tooltip'
                              >
                                <AiFillEdit className='cursor-pointer w-5 h-5 text-slate-600' />
                              </span>
                            </li>
                        )}
                      {(manager?.add || user?.role === "admin") && (
                          <Link
                            title={t('O_VIEW')}
                            className="text-danger ml-2"
                            onClick={() => toggleViewModal(item)}
                          >
                            <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />
                          </Link>
                        )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(serviceProviders) ? (
              <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-2 px-2" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
   {paginationObj?.totalItems ? (<Pagination
      handlePageClick={handlePageClick}
      options={paginationObj}
      page={page}
    />) : null}
          </div>
        </div>
      </div>
      <>
      {showModal && <ServiceProviderModal serviceId={livestockServiceId} show={showModal} onHide={toggleModal} getServiceProvider={getServiceProvider} editData={item} setPage={setPage} />}
      
      {viewShowModal && <ServiceProviderViewModal show={viewShowModal} onHide={toggleViewModal} getServiceProvider={getServiceProvider} editData={item} setPage={setPage} />}
      {viewDesShowModal ? (
        <DesView
          setViewDesShowModal={setViewDesShowModal}
          description={description}
        />
      ) : null}
      </>
    </div>
  );
};

export default LiveStockOnFieldServiceProviderList;
